import { NOTIFICATIONS_PAGE } from '../ids';
import { InstallLocation } from '../types';
export const ids = NOTIFICATIONS_PAGE;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    numbers: {
        key: 'notificationsCount',
        default: 0,
    },
    installLocation: InstallLocation.Standalone,
    method: 'addApplication',
    menuOrder: 4,
    social: false,
    urlOverride: 'notifications',
    uninstallable: true,
    page: {
        name: t('member-pages.notifications.name'),
        shortDescription: t('member-pages.notifications.subtitle'),
        iconURL: `${staticsUrl}assets/images/icons/members-area-icon.svg`,
        description: '',
        origin: '',
        screenshots: [],
    },
});
//# sourceMappingURL=notifications-page.js.map